// ModalA.tsx
import CloseIcon from "@mui/icons-material/Close";
import {
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Typography,
	useMediaQuery,
} from "@mui/material";
import { GroupA } from "@src/ruix";
import { ModalAProps } from "@src/ruix/types";
import React from "react";

const ModalA: React.FC<ModalAProps> = ({
	isOpen,
	onClose,
	title,
	children,
	maxWidth,
	bgColor,
	zIndex,
	preventCloseBgClick,
	fitContentDesktop,
}) => {
	const isMobile = useMediaQuery("(max-width:768px)");

	const dialogTitleStyle = {
		// backgroundColor: "var(--primary)",
		color: "white",
		position: "relative",
		height: "50px",
	};

	const closeButtonStyle = {
		position: "absolute",
		right: "8px",
		top: "8px",
		color: "gray",
	};

	return (
		<Dialog
			open={isOpen}
			onClose={preventCloseBgClick ? undefined : onClose}
			fullWidth={isMobile}
			fullScreen={isMobile}
			maxWidth={false}
			sx={{
				zIndex: typeof zIndex === "number" ? zIndex : undefined,
			}}
			PaperProps={{
				style: {
					width: isMobile ? "100%" : maxWidth || "600px",
					maxWidth: isMobile ? "100%" : maxWidth || "600px",
					maxHeight: isMobile ? "100%" : "calc(100vh - 40px)",
					height: isMobile
						? "100%"
						: fitContentDesktop
						? "auto"
						: "calc(100vh - 40px)",
					backgroundColor: bgColor ? bgColor : "var(--bg-white)",
					borderRadius: "10px",
					position: "relative",
				},
			}}
		>
			{title && (
				<DialogTitle sx={dialogTitleStyle}>
					<Typography color={bgColor ? "black" : undefined}>{title}</Typography>
					<IconButton sx={closeButtonStyle} onClick={onClose}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
			)}
			{!title && (
				<DialogTitle sx={dialogTitleStyle}>
					<IconButton sx={closeButtonStyle} onClick={onClose}>
						<CloseIcon
							style={{
								fontSize: "36px",
							}}
						/>
					</IconButton>
				</DialogTitle>
			)}
			<DialogContent
				sx={{
					backgroundColor: "transparent",
					padding: isMobile ? "30px 10px" : "20px 30px",
					// overflowY: "visible",
				}}
			>
				<GroupA
					style={{
						position: "static",
					}}
					order="column-center-start"
				>
					{children}
				</GroupA>
			</DialogContent>
		</Dialog>
	);
};

export default ModalA;
